import api from './api';

const dashboardService = {
  // Obtener estadísticas del dashboard
  getEstadisticas: async () => {
    try {
      const response = await api.get('/dashboard/estadisticas-usuarios');
      return response.data;
    } catch (error) {
      console.error('Error obteniendo estadísticas:', error);
      throw error;
    }
  }
};

export default dashboardService;
